import { z } from 'zod';
/** An IANA zone name the platform knows, such as `Europe/Berlin`; rule guards are read in it. */
export const timeZoneSchema = z
    .string()
    .min(1)
    .max(64)
    .refine(isTimeZone, { message: 'must be a known time zone, such as Europe/Berlin' });
function isTimeZone(value) {
    try {
        return new Intl.DateTimeFormat('en-GB', { timeZone: value }).resolvedOptions().timeZone !== '';
    }
    catch {
        return false;
    }
}
export const currentUserSchema = z.object({
    id: z.string().min(1),
    displayName: z.string().min(1),
    email: z.string().nullable(),
    timeZone: z.string().min(1),
});
/** The only thing a user may change about themselves; the profile comes from the provider. */
export const updateCurrentUserRequestSchema = z.object({
    timeZone: timeZoneSchema,
});
export const logoutResponseSchema = z.object({
    /** Where the browser goes next, so the identity provider can end its session too. */
    logoutUrl: z.url(),
});
/** Why the login callback sent the browser back, as `/?authError=<code>`. */
export const authErrorCodeSchema = z.enum(['login_failed', 'login_expired']);
export const AUTH_ERROR_PARAM = 'authError';
export const errorResponseSchema = z.object({
    message: z.string().min(1),
});
//# sourceMappingURL=auth.js.map